(() => {
  if (window.wohnjoyProductSupportBound) return;
  window.wohnjoyProductSupportBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.wj-buyhelp__back');
    if (!link) return;
    const target = document.getElementById('MainContent');
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  document.addEventListener('shopify:block:select', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const question = target.closest('.wj-buyhelp__question') || target.querySelector('.wj-buyhelp__question');
    if (question) question.open = true;
  });
})();
